import { render, staticRenderFns } from "./the-modals.vue?vue&type=template&id=2fda6635&scoped=true&"
import script from "./the-modals.vue?vue&type=script&lang=js&"
export * from "./the-modals.vue?vue&type=script&lang=js&"
import style0 from "./the-modals.vue?vue&type=style&index=0&id=2fda6635&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fda6635",
  null
  
)

export default component.exports